// extracted by mini-css-extract-plugin
export default {"splitRow":"IybY8M","section":"CGXQqQ"};